import { getSignedURLSApi } from '../http-clients/signed-url.client'
import { isValidFTSS3Bucket } from './utils'

export const getSignedOrPublicURL = async (url: string): Promise<string> => {
    if (!isValidFTSS3Bucket(url)) {
        return url
    }

    const resourceName = url.split('/').slice(3).join('/')
    if (resourceName.length === 0) {
        return ''
    }

    const resp = await getSignedURLSApi(resourceName)
    if (!resp.isOk()) {
        return ''
    }
    return resp.value
}
